var TrilliumRedirectToUrl = (function ($) {

    var trilliumRedirectToUrlSelector = '.tri-redirect-url';

    var redirectToUrl = function () {
        var elem = $(trilliumRedirectToUrlSelector);

        if (elem !== undefined &&
            elem.length > 0) {
            var url = elem.data('redirect-url');
            var timer = elem.data('redirect-timer');

            if (url !== undefined) {
                if (timer === undefined || timer === null || isNaN(timer)) {
                    timer = 3000;
                }

                setTimeout(function () { window.location.href = url; }, timer);
            }
        }
    };

    return {
        init: function () {
            if ($(trilliumRedirectToUrlSelector).length) {
                redirectToUrl();
            }
        }
    };

})(window.jQuery);

window.TrilliumRedirectToUrl = TrilliumRedirectToUrl;
